import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Spinner, Alert } from 'reactstrap';
import { get } from '../../helpers/api_helper';

import ListingForm from '../../components/Listing/ListingForm';
import * as url from '../../helpers/url_helper';

// eslint-disable-next-line no-unused-vars
function EditListingForm(props) {
  const history = useHistory();
  const { id } = useParams();

  const [listing, setListing] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const uri = `/api/listings/data/${id}`;

      try {
        const obj = await get(uri);

        setListing(obj);
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData(id);
  }, []);

  const onSuccess = (r) => {
    history.push(`/listing/${r.id}`);
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {error && (
          <Alert color="danger" className="mt-3" isOpen>
            {error}
          </Alert>
        )}
        {loading && (
          <Spinner style={{ width: '4rem', height: '4rem' }} type="border" color="info" />
        )}
        {!loading && (
          <ListingForm actionUrl={url.POST_LISTING} onSuccess={onSuccess} entity={listing} />
        )}
      </div>
    </div>
  );
}

EditListingForm.defaultProps = {
  t: (x) => (x),
};

EditListingForm.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(EditListingForm));
